import type { ReactNode } from 'react'

/** The one heading style for an inspector section, shared with Disclosure and the data footer so
 *  headings outrank the field labels beneath them (small, dark, semibold; labels are quieter). */
export const SECTION_TITLE_CLASS = `text-xs font-semibold text-default`

/** A flat section of the inspector: a heading and a stack of fields. Sections are separated by
 *  the inspector body's dividers, never by nested cards (design language rule 1). */
export function Section({ title, children }: { title?: string; children: ReactNode }) {
  return (
    <section className="py-4 first:pt-0 last:pb-0">
      {title && <div className={`mb-3 ${SECTION_TITLE_CLASS}`}>{title}</div>}
      <div className="space-y-3">{children}</div>
    </section>
  )
}
